import jQuery from "jquery";

(function($) {
    let suggestionTimeout;
    const $loadingIndicator = $('#loading-indicator');
    const $suggestionsContainer = $('#suggestions-container');
    const $resultsListContainer = $('#search-results-list');
    const $searchInput = $('#search-input');
    const $searchButton = $('#search-button');
    const $loadMoreButton = $('#load-more-button');
    let currentPage = 1;

    
    // On page load, check for search_q in URL and trigger search
    // Automatically open the search modal if search_q is present in the URL
    $(function() {
        const currentUrl = new URL(window.location.href);
        const searchQ = currentUrl.searchParams.get('search_q');

        if (searchQ && searchQ.trim() !== '') {
            // Open the modal using Foundation's reveal method
            $('#search-modal').foundation('open');

            // Set the search input value to the query from the URL
            $searchInput.val(searchQ);
            currentPage = 1;
            performSearch(searchQ, currentPage);
        }
    });

    // fetch suggestions from the server
    function getSuggestions(query) {
        if (query.length < 3) {
            $suggestionsContainer.empty(); // Clear suggestions if query is too short
            return;
        }

        clearTimeout(suggestionTimeout);
        suggestionTimeout = setTimeout(() => {
            $.ajax({
                url: '/search/suggestions',
                method: 'GET',
                data: { search_q: query },
                beforeSend: function () {
                    $suggestionsContainer.empty();
                },
                success: function (data) {
                    if (data.suggestions && data.suggestions.length > 0) {
                        const $suggestionsList = $('<ul>').addClass('suggestions-list');
                        // Build suggestion list using safe text nodes and attributes
                        data.suggestions.forEach(function (suggestion) {
                            if (suggestion === query.trim()) return; // Skip if suggestion is the same as query

                            const $suggestionLink = $('<a>')
                                .addClass('suggestion-link')
                                .attr('href', '#')
                                .attr('data-suggestion', suggestion)
                                .text(suggestion);

                            const $suggestionItem = $('<li>')
                                .addClass('suggestion-item')
                                .text('Did you mean ')
                                .append($suggestionLink)
                                .append('?');

                            $suggestionsList.append($suggestionItem);
                        });

                        $suggestionsContainer.append($suggestionsList);
                    } else {
                        $suggestionsContainer.empty().append($('<p>').text('No suggestions found.'));
                    }
                },
                error: function () {
                    $suggestionsContainer.empty().append($('<p>').text('Error fetching suggestions.'));
                },
            });
        }, 300); // Add a debounce delay of 300ms
    }

    // Handle suggestion click event
    $suggestionsContainer.on('click', '.suggestion-link', function (event) {
        event.preventDefault();
        const selectedSuggestion = $(this).data('suggestion').trim();
        $searchInput.val(selectedSuggestion);
        performSearch(selectedSuggestion);
    });

    // Helper function to trim the title
    function trimTitle(title, maxLength = 40) {
        return title.length > maxLength ? title.substring(0, maxLength) + ' ...' : title;
    }

    // Simple URL sanitizer to allow only safe protocols/paths for hrefs
    function isSafeHref(url) {
        if (!url || typeof url !== 'string') return false;
        const trimmed = url.trim();
        // allow relative paths, anchor links, and http(s) absolute URLs
        return trimmed === '#' || /^\//.test(trimmed) || /^https?:\/\//i.test(trimmed);
    }

    // Simple image src sanitizer: allow http(s), root-relative and data:image/* base64
    function isSafeImageSrc(url) {
        if (!url || typeof url !== 'string') return false;
        const trimmed = url.trim();
        return /^\//.test(trimmed) || /^https?:\/\//i.test(trimmed) || /^data:image\/(png|jpe?g|gif|webp);base64,/i.test(trimmed);
    }

    // Perform search and display results
    function performSearch(query, page = 1) {
        $.ajax({
            url: '/search',
            method: 'GET',
            data: { search_q: query, page: page },
            beforeSend: function () {
                $loadingIndicator.show();
                if (page === 1) {
                    $resultsListContainer.empty(); // Clear previous results for the first page
                }

                // Update the URL with the search query
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('search_q', query);
                window.history.replaceState({}, '', currentUrl);
            },
            success: function (data) {
                if (data.success && data.data.length > 0) {
                    data.data.forEach(function (item) {
                        const trimmedTitle = trimTitle(item.title || ''); // Trim the title

                        // Build result item DOM safely
                        const $resultItem = $('<div>').addClass('cell search-result-item margin-top-1 margin-bottom-1');

                        const $resultItemRoot = $('<div>').addClass('result-item');

                        const $header = $('<div>').addClass('result-item-header');

                        const $grid = $('<div>').addClass('grid-x small-up-2');
                        $grid.append($('<div>').addClass('cell align-left').text(item.type || ''));
                        $grid.append($('<div>').addClass('cell align-right').text(item.productCategory || ''));

                        $header.append($grid);

                        const $titleWrap = $('<div>').addClass('margin-bottom-1 result-item-title');
                        $titleWrap.append($('<h3>').text(trimmedTitle));
                        $header.append($titleWrap);

                        // View more link (only if safe URL)
                        if (isSafeHref(item.url)) {
                            const $viewMoreWrap = $('<div>').addClass('result-item-link margin-bottom-1');
                            const $viewMoreAnchor = $('<a>')
                                .addClass('link-url')
                                .attr('href', item.url)
                                .attr('target', '_blank')
                                .text('View more');
                            $viewMoreWrap.append($viewMoreAnchor);
                            $header.append($viewMoreWrap);
                        }

                        $resultItemRoot.append($header);

                        const $imageContainer = $('<div>').addClass('result-item-image-container padding-1');
                        if (isSafeImageSrc(item.image)) {
                            const $img = $('<img>')
                                .addClass('result-item-image')
                                .attr('src', item.image)
                                .attr('alt', item.title || '')
                                .attr('title', item.title || '');
                            $imageContainer.append($img);
                        }

                        $resultItemRoot.append($imageContainer);

                        $resultItem.append($resultItemRoot);

                        $resultsListContainer.append($resultItem);
                    });

                    // Show or hide the "Load More" button
                    if (data.hasNextPage) {
                        $loadMoreButton.show();
                    } else {
                        $loadMoreButton.hide();
                    }
                } else if (page === 1) {
                    $resultsListContainer.empty().append($('<p>').text('No results found.'));
                }
            },
            error: function () {
                if (page === 1) {
                    $resultsListContainer.empty().append($('<p>').text('Error fetching results.'));
                }
            },
            complete: function () {
                $loadingIndicator.hide();
            },
        });
    }

    // Handle search input and button click events
    function handleSearch($type = 'all') {
        const query = $searchInput.val().trim();
        if (query) {
            if ($type === 'search' || $type === 'all') {
                performSearch(query, currentPage); // Call performSearch with the query for full search
            } else {
                getSuggestions(query); // Fetch suggestions
            }
        }
    }

    // Load more results when the button is clicked
    function loadMoreResults() {
        const query = $searchInput.val().trim();
        if (query) {
            currentPage++;
            performSearch(query, currentPage);
        }
    }

    // Event listeners for search input
    $searchInput.on('input', function () {
        currentPage = 1; // Reset to the first page
        handleSearch('suggestions');
    });

    // Event listeners for enter key
    $searchInput.on('keypress', function (event) {
        if (event.key === 'Enter') {
            currentPage = 1; // Reset to the first page
            handleSearch('search');
        }
    });

    // Event listeners for search button
    $searchButton.on('click', function () {
        currentPage = 1; // Reset to the first page
        handleSearch('search');
    });

    window.loadMoreResults = loadMoreResults; // Expose the function globally for the button

    // handle the modal open event
    $(document).on('closeme.zf.reveal', '#search-modal[data-reveal]', function() {
        $('#search-modal').css('top', '0');
        $('#search-modal .header.sticky').css('max-width', 'inherit');
        // Do not clear results here
    });

    // handle the modal close event
    $(document).on('closed.zf.reveal', '#search-modal[data-reveal]', clearResults);
    
    function clearResults() {
        $searchInput.val(''); // Clear the search input
        $suggestionsContainer.empty(); // Clear suggestions
        $resultsListContainer.empty(); // Clear previous results

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('search_q');
        window.history.replaceState({}, '', currentUrl);

        $loadMoreButton.hide();
    }
})(jQuery);